import { JobTypeFilterMap, QueryState } from "./types";

import { ES_BASE_URL } from "~/Constant";

export const QUERYSTATE_INITIAL_STATE: QueryState = {
  q: "",
  location: "",
  locationSlug: "",
  department: "",
  employmentType: "",
  marketIds: "",
  commuteFilter: false,
  commuteLat: "",
  commuteLon: "",
  commuteLabel: "",
  commutePlaceId: "",
  jobType: "",
  jobLocationLat: "",
  jobLocationLon: "",
  jobLocationAddress: "",
};

export const GUTTER_SMALL = 8;
export const GUTTER_MEDIUM = 16;
export const GUTTER_LARGE = 24;

export const GENERAL_APPLICATION_LINK = `${ES_BASE_URL}/careers/apply`;
export const GENERAL_JOB_BOARD_LINK = `${ES_BASE_URL}/careers/current-openings`;

export const JOB_TYPE_FILTER_MAP: JobTypeFilterMap = [
  {
    frontend: "Remote",
    backend: "Fully remote",
  },
  {
    frontend: "Hybrid",
    backend: "Hybrid",
  },
  {
    frontend: "On-Site",
    backend: "On site",
  },
];
